export const INIT = 'init' 
export const SET_LOADING = 'setLoading' 
export const SET_LISTS = 'setLists' 
export const ADD_LISTS = 'addLists'
export const DELETE_LISTS = 'deleteLists'
export const UPDATE_LIST = 'updateList'
